import {useState} from "react";
import {Box,Collapse,IconButton,Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {useTheme} from '@mui/material/styles';
import {alpha} from '@mui/material/styles';

const CollapsibleSection=({
    title_label='missingLabel',
    expanded=true,
    children
})=>{
    const [open,setOpen]=useState(expanded);
    const theme=useTheme();

    return (
        <Box
            sx={{
                overflow:"hidden",
                mb:1,
            }}>
            <Box
                onClick={()=>setOpen(!open)}
                sx={{
                    display:"flex",
                    alignItems:"center",
                    px:2,
                    cursor:"pointer",
                    userSelect:"none",
                    backgroundColor:alpha(theme.palette.primary.main, 0.1),
                    color:theme.palette.primary.main,
                }}>
                <IconButton size="small" sx={{color:theme.palette.primary.main}}>{open?<ExpandLessIcon />:<ExpandMoreIcon />}</IconButton>
                <Typography variant="subtitle1" sx={{fontWeight:600}}>{title_label}</Typography>
            </Box>
            <Collapse in={open}>
                <Box sx={{p:1,backgroundColor:alpha(theme.palette.primary.main,0.02)}}>
                    {children}
                </Box>
            </Collapse>
        </Box>
    );
};

export default CollapsibleSection;